import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  MergedRecurrentApplicationResource,
  recurrentApplicationsPut,
  RecurrentApplicationResource,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useEditRecurrentApplication = (
  publisherId: number | undefined,
  id: number,
  options: UseMutationOptions<
    RecurrentApplicationResource,
    unknown,
    MergedRecurrentApplicationResource,
    unknown
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (recurrentApplication) => {
      if (publisherId == null) {
        throw new Error('no publisher id given');
      }
      return extractData(
        recurrentApplicationsPut({
          path: { publisherId, id },
          body: recurrentApplication,
        })
      );
    },
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({ queryKey: ['recurrentApplications'] });
      queryClient.invalidateQueries({ queryKey: ['recurrentApplication', id] });
      options.onSuccess?.(...args);
    },
  });
};
